// extracted by mini-css-extract-plugin
export default {"container":"AudioPlayer_container__-e--t","audio":"AudioPlayer_audio__aUWbj","boton":"AudioPlayer_boton__CbIQJ","toggleSwitch":"AudioPlayer_toggleSwitch__t86z0"};